import { render, staticRenderFns } from "./Personnel-problem-statistics.vue?vue&type=template&id=84e550ba"
import script from "./Personnel-problem-statistics.vue?vue&type=script&lang=js"
export * from "./Personnel-problem-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports